<template lang="html">
  <div class="container-scroller flexbox-container">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex  auth auth-img-bg" :style="'background-image : url(\'/static/images/auth/vuesax-login-bg.jpg\')'">
        <div class="row flex-grow">
          <!-- <div class="col-lg-6 login-half-bg d-flex flex-row">
          </div> -->
          <div class="col-lg-12  align-items-center justify-content-center">
            <div class="m-0 justify-content-center row">
                <div class="d-flex justify-content-center col-sm-8 col-md-8 col-lg-10 col-xl-7">
                  <div class="bg-authentication login-card rounded-0 mb-0 w-100 card">
                    <div class="m-0 row">
                      <div class="d-lg-block d-none text-center align-self-center px-1 py-0 col-lg-6">
                        <img :src='"/static/images/auth/"+bgImage' alt="loginimage">
                      </div>
                      <div class="p-0 col-md-12 col-lg-6">
                        <div class="rounded-0 mb-0 px-2 login-tabs-container" style="background:white !important">
                          <router-view></router-view>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <p class="text-black font-weight-medium text-center flex-grow align-self-end" style="margin-top:20px; color:rgba(0,0,0,.45); font-size:16px">Copyright &copy; 2023  All rights reserved.</p>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
</template>

<script>
export default {
  props: ['bg-image']
}
</script>

<style lang="css" scoped>
  .flexbox-container {
        display: flex;
        align-items: center;
        height: 100vh;
        justify-content: center;
        overflow: hidden;
    }
  .content-wrapper {
    align-items: center;
}
 .bg-authentication {
    background-color: #eff2f7;
  }
  .card {
    background-color: #eff2f7 !important;
    margin-bottom: 2.2rem;
    border: none;
    border-radius: .5rem;
    box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
}
.p-0{
   background-color:white !important;
}

</style>



// WEBPACK FOOTER //
// src/components/LoginLayout.vue